/// <summary name='cafm.panel' type='Object'>CAFM Panel container object</summary>
cafm.panel = {    
    
    setMainHeight: function (el, unavailHeight) {
        /// <summary>Sets the height of the main central panel in the CAFM layout</summary>
        /// <param name="el" type="String">The element to set the height for</param>
        /// <param name="unavailHeight" type="Number">Unavailable amount of height in pixels</param>

        var h = this.getMainHeight();

        if (unavailHeight > 0) {

            h -= unavailHeight;
        }

        el.outerHeight(h);
    },
    setContentHeightToFull: function(){

        var el = $('#mainContentPane');
        el.addClass('noSpacingOrPadding');
        cafm.panel.setMainHeight(el);
    },
    unsetContentHeightToFull: function () {

        $('#mainContentPane').removeClass('noSpacingOrPadding').css('height', 'auto');

    },
    getMainHeight: function () {
        /// <summary>Gets the height of the main central panel in the CAFM layout</summary>
        /// <returns type="Integer">The element height in pixels</returns>

        if (!window.mainHeight) {

            let height = this.getHeaderHeight() || 0;
            height += this.getFooterHeight() || 0;
            window.mainHeight = $(window).height() - height;
        }
        return window.mainHeight;
    },
    getHeaderHeight: function () {

        if (!window.headerHeight) {
            window.headerHeight = $('#siteHeader').outerHeight(true) || 0;
        }
        return window.headerHeight;
    },
    getFooterHeight: function(){

        if (!window.footerHeight) {

            window.footerHeight = $('#footer').outerHeight(true) || 0;
        }
        return window.footerHeight;
    },    
    getContentPaneHeight: function () {
        /// <summary>Gets the height of the main central panel in the CAFM layout</summary>
        /// <returns type="Integer">The element height in pixels</returns>
              
        var mh = this.getMainHeight();
        var mv = cafm.views.mainView();
        var pad = parseInt(mv.css('padding-top')) + parseInt(mv.css('padding-bottom'));
        return mh - pad;
    },
    getMainWidth: function () {
        /// <summary>Gets the width of the main central panel in the CAFM layout</summary>
        /// <returns type="Integer">The element width in pixels</returns>

        return $('#mainContentPane').width();
    }
}